module.exports = __webpack_public_path__ + "img/MB_lobby.15ea5949.jpg";